var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.required && !_vm.web_show)?_c('NetworkError',{on:{"onRefresh":_vm.handleRefresh}}):_vm._e(),(_vm.required && _vm.web_show)?[_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }